import React, { useState, useEffect, useContext } from "react";
import { OrdersContext } from "../../context/OrdersContext";
import {
  getFirestore,
  collection,
  getDocs,
} from "firebase/firestore";
import { mapDocs, statusList } from "../../utils";
import { OrdersByStatus } from "./components/OrdersByStatus";
import { CourierTable } from "./components/CourierTable";
import { PieCourier } from "./components/PieCourier";
import { Card, Col, Row, DatePicker,Select } from "antd";
import { ProductsTable } from "./components/ProductsTable";
import { CancelProducts } from "./components/CancelProducts"; 

const { RangePicker } = DatePicker;
const { Option } = Select;

const statusOptions = statusList ? Object.keys(statusList) : [];

const dateFormat = "DD-MM-YYYY";

export const BoardOperationsOne = () => {
  const {
    filteredOrdersByEnd,
    dateFilter,
    isLoadingSales,
    isLoadingDateFilteredData,
    statusFilter,
    setStatusFilter,
    setDateFilter,
  } = useContext(OrdersContext);
  const [products, setProducts] = useState([]);
  const [isLoadingProducts, setIsLoadingProducts] = useState(true);

  useEffect(() => {
    const querydb = getFirestore();
    let isMounted = true;
    setIsLoadingProducts(true);

    getDocs(collection(querydb, "products")).then((res) => {
      if (isMounted) setProducts(mapDocs(res));
      setIsLoadingProducts(false);
    });
    setIsLoadingProducts(false);
    return () => {
      isMounted = false;
    };
  }, []);

  const isLoading =
    isLoadingSales || isLoadingDateFilteredData || isLoadingProducts;

  if (isLoading) {
    return (
      <div className="mt-10 ml-5">
        Cargando Operaciones...
      </div>
    );
  } else {
    return (
      <div className="flex justify-center h-fit">
        <div className="grid-rows-custom grid-cols-custom gap-x-0 gap-y-0 m-5 w-full xl:w-11/12">
          <div>
            <div
            className="flex justify-end"
            >
              <div className="mr-5 w-80 pb-4">
                <RangePicker
                  value={dateFilter}
                  onChange={(dates) => setDateFilter(dates)}
                  format={dateFormat}
                />
              </div>
              <div>
                <Select
                  mode="multiple"
                  value={
                    statusFilter.length ? statusFilter : ["Todos los estados"]
                  }
                  onChange={(value) => {
                    if (
                      value.includes("Todos los estados") &&
                      statusFilter.length === 1
                    ) {
                      setStatusFilter(["Todos los estados"]);
                    } else {
                      setStatusFilter(
                        value.filter((item) => item !== "Todos los estados")
                      );
                    }
                  }}
                  style={{ minWidth: 200 }}
                >
                  <Option disabled value="Todos los estados">
                    Todos los estados
                  </Option>
                  {statusOptions?.map((option) => (
                    <Option key={option} value={option}>
                      {option}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
          </div>
          <Col className="my-4" xs={24} sm={24} md={24} lg={24} xl={24}>
            <Card bodyStyle={{ display: "none" }} xs={24} sm={24} md={24} lg={24} xl={12} cover={<OrdersByStatus orders={filteredOrdersByEnd} />}/>
          </Col>
          <Col className="my-4" xs={24} sm={24} md={24} lg={24} xl={24}>
              <ProductsTable data={products} />
          </Col>
          <div className="my-4">
            <Row gutter={16} className="flex flex-col xl:flex-row">
            <Col className="pb-4" xs={24} sm={24} md={24} lg={24} xl={12}>
                <CourierTable data={filteredOrdersByEnd} />
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={12}>
                <PieCourier data={filteredOrdersByEnd} />
              </Col>
            </Row>
          </div>
          <Col className="my-4" xs={24} sm={24} md={24} lg={24} xl={24}>
            <CancelProducts data={filteredOrdersByEnd} />
          </Col>
        </div>
      </div>
    );
  }
};
